import React from 'react';
import TagsForm from './TagsForm';

const NewTagPage = () => {
    return (
        <TagsForm formType='create' currentTagId={null} />
    );
};

export default NewTagPage;

